import { ReactNode } from 'react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';

interface FolderSectionProps {
    title: string;
    count?: number;
    action?: { label: string; onClick: () => void };
    children: ReactNode;
}

export const FolderSection = ({
    title,
    count,
    action,
    children,
}: FolderSectionProps) => (
    <Card className="overflow-hidden border-subtle shadow-none">
        <header className="flex items-center justify-between gap-3 px-4 py-3">
            <div className="flex min-w-0 items-center gap-2.5">
                <h2 className="min-w-0 break-words text-sm font-semibold text-foreground">
                    {title}
                </h2>
                {count !== undefined && (
                    <span className="shrink-0 rounded-full border border-subtle bg-muted px-[7px] text-[11px] font-medium tabular-nums text-subtle-foreground">
                        {count}
                    </span>
                )}
            </div>
            {action && (
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={action.onClick}
                    className="h-auto shrink-0 px-2 py-1 text-xs font-medium text-subtle-foreground hover:text-foreground"
                >
                    {action.label}
                </Button>
            )}
        </header>
        <div className="border-t border-subtle">{children}</div>
    </Card>
);
